import { keyframes } from "@emotion/react";

const HeadFont = '"Inter", sans-serif';
// const HeadFont = '"Barlow", sans-serif';

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-150px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }z
`;
const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(150px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;
const slideInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(150px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const styles = {
  leader_board: {
    width: 40,
    height: 40,
    borderRadius: 1.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "15px",
    boxShadow: 3,
  },

  square_icon: {
    height: { lg: "43%", md: "4vh" },
    minHeight: "43%",
    width: "40%",
    mx: 6,
    textAlign: "center",
    alignItems: "center",
    alignContent: "center",
    p: 1,
    borderRadius: "8px",
    border: "solid 0.5px #6E73F2",
    background: "linear-gradient(135deg, #6E73F2 0%, #9C4DF4 100%)",
    // background:
    //   "linear-gradient(90deg, rgb(6, 33, 106) 18%, rgb(59, 78, 145) 100%, rgb(228, 224, 224))",
    // background:
    //   "linear-gradient(90deg, rgb(132, 191, 242) 18%, rgb(59, 78, 145) 100%, rgb(228, 224, 224))",
    boxShadow: "0px 5px 4px rgb(172, 169, 169)",
  },

  square_text: {
    fontSize: { lg: "1.4em", md: "1em" },
    fontWeight: "bold",
    color: "rgb(44, 45, 44)",
    // color: "rgb(35, 199, 21)",
    mt: 2,
  },
  ai_knows: {
    animation: `${slideInUp} 0.5s ease-out`,
    width: "100vw",
    fontSize: { lg: "4.3em", xs: "3em" },
    alignItems: "center",
    textAlign: "center",
    fontWeight: "bold",
    paddingTop: "5%",
    // fontFamily: "'Michroma', 'Roboto', sans-serif",
    fontFamily: '"marcellus", sans-serif',
  },
  when_Scale: {
    animation: `${slideInUp} 0.5s ease-out`,
    // fontFamily: "'Michroma', 'Roboto', sans-serif",
    fontFamily: '"marcellus", sans-serif',
    letterSpacing: "-0.5px",
    wordSpacing: "-0.7px",
    fontSize: "0.9em",
    fontWeight: 600,
    fontStyle: "normal",
    //   background:
    //     "linear-gradient(90deg, rgb(19, 160, 203), rgb(0, 81, 233), rgb(127, 54, 229))",
    // background:
    //   "linear-gradient(90deg, rgb(11, 11, 11), #6E73F2, rgb(0, 0, 0))",
    // backgroundSize: "100%",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    // display: "inline-block",
  },
  book_demo: {
    // width: { lg: "10vw", xs: "50vw", md: "20vw", sm: "20vw" },
    width: { lg: "12%", xs: "50vw", md: "15%", sm: "20vw" },
    fontSize: "1em",
    textTransform: "capitalize",
    borderRadius: "10px",
    color: "white",
    height: { lg: "4.5vh", md: "3vh" },
    fontWeight: "bold",
    border: "solid 0.5px rgb(48, 50, 97)",
    backgroundColor: "rgb(52, 56, 149)",
    boxShadow: "0px 5px 4px rgb(183, 190, 203)",
    "&:hover": {
      transform: "scale(1.05)",
      filter: "brightness(1.1)",
      boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.3)",
      cursor: "pointer",
    },
  },
  green_box: {
    animation: `${slideInLeft} 0.8s ease-out`,
    flexGrow: 1,
    p: 3,
    ml: 5,
    mt: 18,
    height: "160px",
    width: "200px",
    borderRadius: "12px",
    backgroundColor: "rgb(246, 255, 248)",
    boxShadow: "0px 8px 18px rgba(73, 72, 72, 0.3)",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      border: "solid 1.9px rgb(56, 161, 77)",
      transform: "scale(1.05)",
      filter: "brightness(1.05)",
      boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.35)",
    },
  },

  main_hover_box: {
    display: "flex",
    flexGrow: 1,
    p: 3,
    animation: `${slideInRight} 0.8s ease-out`,
    borderRadius: "12px",
    backgroundColor: "rgb(243, 248, 253)",
    boxShadow: "0px 8px 18px rgba(73, 72, 72, 0.3)",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      border: "solid 1.9px rgb(60, 103, 213)",
      transform: "scale(1.05)",
      filter: "brightness(1.05)",
      boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.35)",
    },
  },
  full_transparency: {
    fontSize: { lg: "2.8em", xs: "2em" },
    fontWeight: 600,
    color: "rgb(137, 169, 213)",
    fontFamily: '"marcellus", sans-serif',
    background:
      "linear-gradient(90deg, rgb(11, 11, 11), rgb(105, 109, 223), rgb(0, 0, 0))",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block",
    fontStyle: "normal",
    alignContent: "center",
    pb: 1,
    textAlign: "center",
    justifyItems: "center",
    width: { lg: "80vw", xs: "95vw" },
    lineHeight: "46px",
  },

  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    px: { xs: 2, sm: 4, md: 8 },
    py: { xs: 4, md: 8 },
  },

  // Parent flexible container that becomes column on small screens
  row: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: 3, md: 4 },
    alignItems: "stretch", // ensures equal height
    width: "80%",
    boxSizing: "border-box",
  },

  card: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "stretch",
    height: "100%",
    flex: 1, // expand to fill Grid item
    width: "100%", // allow child to control spacing
    minHeight: { xs: "auto", sm: "420px" }, // prevents collapsing on larger screens but not rigid
    px: { xs: 2, sm: 3 },
    py: { xs: 2, sm: 3 },
    border: "1px solid",
    borderColor: "divider", // uses theme divider color
    borderRadius: 3, // rounded corners (theme spacing unit)
    boxShadow: 1,
    boxSizing: "border-box", // 🔑 Fix shift
  },
  headingBlock: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
  },

  subHead: {
    fontSize: { xs: "0.95rem", sm: "1.03rem", md: "1.1rem" },
    color: "text.secondary",
  },

  paraList: {
    mt: 2,
    display: "flex",
    flexDirection: "column",
    gap: { xs: 1.2, sm: 1.6 },
    minWidth: 0,
    "& .para": {
      display: "flex",
      alignItems: "flex-start",
      gap: 1,
      lineHeight: 1.45,
      fontSize: { xs: "0.95rem", sm: "1rem" },
      wordBreak: "break-word",
      minWidth: 0,
    },
  },

  imageWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: { xs: 2.5, sm: 3 },
    minWidth: 0,
  },

  // Image itself won't force the card to expand beyond the card width
  image: {
    width: { xs: "60%", sm: "55%", md: "50%", lg: "45%" },
    maxWidth: { xs: 220, sm: 280, md: 340, lg: 420 },
    height: "auto",
    objectFit: "contain",
    display: "block",
    flexShrink: 0,
  },

  circleIcon: {
    mt: "6px",
    fontSize: { xs: 12, sm: 14, md: 16, lg: 12 },
    color: "primary.main",
    flexShrink: 0,
  },

  //------------------------------------------

  silent_drain: {
    backgroundColor: "rgb(253, 235, 235)",
    // border: "solid 0.8px rgb(185, 43, 43)",
    color: "rgb(238, 62, 59)",
    borderRadius: "23px",
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: { lg: "0.9em", md: "0.7em", xs: "0.9em" },
    height: "5vh",
    alignContent: "center",
    fontFamily: { HeadFont },
    width: { lg: "21%", md: "20%", sm: "30%", xs: "62%" },
    ml: { lg: 0, xs: 2 },
    justifyContent: "center",
    // boxShadow: "0px 4px 4px rgb(251, 219, 219)",
  },
  budget_main_head: {
    fontSize: { lg: "2.5em", md: "1em", xs: "1.4em" },
    pt: 2,
    px: { lg: 0, xs: 3 },
    // fontFamily:{HeadFont},
    fontFamily: '"Inter", sans-serif',
    textAlign: "left",
    color: "rgb(59, 59, 59)",
    fontWeight: 600,
    fontStyle: "normal",
  },
  budget_column: {
    display: "flex",
    flexDirection: "column",
    gap: 1.25,
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0px 4px 14px rgb(233, 236, 252)",
    borderRadius: "12px",
    backgroundColor: "rgb(255, 255, 255)",
    height: "100%",
    p: { lg: 2, md: 1.5, xs: 1 },
    boxSizing: "border-box",
    width: { lg: "18vw", xs: "80vw" },
    maxWidth: { xs: "100%", sm: 360, md: 300, lg: 270 },
    minWidth: 0,
  },
  budget_awsmo: {
    color: "#a17efd",
    fontWeight: 500,
    fontFamily: '"Inter", sans-serif',
    fontStyle: "normal",
    fontSize: { lg: "1.3em", sm: "1em", md: "0.8em", xs: "1.1em" },
  },
  budget_head: {
    fontSize: { lg: "1.6em", md: "0.9em", xs: "1.2em" },
    fontFamily: '"Inter", sans-serif',
    fontWeight: "bold",
    color: "rgb(49, 49, 49)",
  },
  budget_para: {
    boxSizing: "border-box",
    color: "rgb(81, 81, 81)",
    width: "100%", // full width of the card
    maxWidth: "100%",
    height: "auto", // allow natural height
    lineHeight: { lg: "22px", md: "20px", xs: "18px" },
    fontStyle: "normal",
    fontSize: { lg: "0.95rem", md: "0.9rem", xs: "0.9rem" },
    fontWeight: 500,
    textAlign: "center",
    wordBreak: "break-word", // break long words
    overflowWrap: "anywhere",
    whiteSpace: "normal",
    minWidth: 0, // critical for flex children
    // on very short screens allow vertical scroll inside the card so text is reachable
    maxHeight: { xs: "calc(100vh - 180px)", sm: "none" },
    overflowY: { xs: "auto", sm: "visible" },
    py: 0.5,
  },
  textfield: {
    p: 1,
    height: "5vh",
    width: { lg: "26vw", xs: "78vw" },
    border: "solid 1px #dddedeff",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    "& .MuiInputBase-input": {
      fontSize: "0.9rem", // change text inside field
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.8rem", // change label size
    },
  },
};
